module.exports = __webpack_public_path__ + "img/empty_data_icon.4922cdb5.png";